module.exports = __webpack_public_path__ + "img/hot.ef53348.svg";